var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("validation-provider", {
            attrs: { rules: "area", mode: "lazy", name: _vm.nomeAba + "/Área" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("Label", {
                          attrs: { label: "Área", obrigatorio: "" }
                        }),
                        _vm._v(" "),
                        _c("AppInputDouble", {
                          class: { "input erro": errors.length },
                          attrs: {
                            name: "Área",
                            precision: 2,
                            onkeypress: _vm.onlyInputNumbers,
                            showAppend: true
                          },
                          model: {
                            value: _vm.pratica.area,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "area", $$v)
                            },
                            expression: "pratica.area"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: "required",
              mode: "lazy",
              name: _vm.nomeAba + "/Data início da implementação"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("Label", {
                          attrs: {
                            label: "Data de início da implementação",
                            obrigatorio: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          class: { "input erro": errors.length },
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            placeholder: "Selecione mês e ano",
                            format: "MM/yyyy",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.pratica.dataInicio,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "dataInicio", $$v)
                            },
                            expression: "pratica.dataInicio"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("TitleWithRow", { attrs: { title: "Componentes do sistema" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-2" },
        [
          _c("EspecieEspacamento", {
            attrs: {
              optionsSelect: _vm.slct.opcoesEspeciesFlorestaisSaf,
              tituloCard: "Espécie florestal",
              label1: "Espécies florestais",
              nomeArraySalvar: "especies",
              pratica: _vm.pratica,
              nomeAba: _vm.nomeAba,
              tipoEspecie: _vm.tiposEspeciesFlorestais.ESPECIE_FLORESTAL
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-2" },
        [
          _c("EspecieEspacamento", {
            attrs: {
              optionsSelect: _vm.slct.opcoesEspeciesFrutiferas,
              tituloCard: "Espécie frutífera",
              label1: "Espécies frutíferas",
              nomeArraySalvar: "especies",
              pratica: _vm.pratica,
              nomeAba: _vm.nomeAba,
              tipoEspecie: _vm.tiposEspeciesFlorestais.ESPECIE_FRUTIFERA
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-2" },
        [
          _c("EspecieEspacamento", {
            attrs: {
              optionsSelect: _vm.slct.opcoesEspeciesCicloCurto,
              tituloCard: "Espécie ciclo curto e médio",
              label1: "Espécies ciclo curto e médio",
              nomeArraySalvar: "especies",
              pratica: _vm.pratica,
              nomeAba: _vm.nomeAba,
              tipoEspecie:
                _vm.tiposEspeciesFlorestais
                  .ESPECIE_ALIMENTAR_CICLO_CURTO_E_MEDIO
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("EspecieEspacamento", {
        attrs: {
          optionsSelect: _vm.slct.opcoesEspeciesAdubadeiras,
          tituloCard: "Espécie adubadeira ou de serviço",
          label1: "Espécies adubadeiras ou de serviço",
          nomeArraySalvar: "especies",
          pratica: _vm.pratica,
          nomeAba: _vm.nomeAba,
          tipoEspecie:
            _vm.tiposEspeciesFlorestais.ESPECIE_ADUBEIRAS_OU_DE_SERVICO
        }
      }),
      _vm._v(" "),
      _c("Bioinsumos", {
        attrs: { pratica: _vm.pratica, nomeAba: _vm.nomeAba }
      }),
      _vm._v(" "),
      _c("Irrigacao", {
        attrs: { pratica: _vm.pratica, nomeAba: _vm.nomeAba }
      }),
      _vm._v(" "),
      _c("Financiamentos", {
        attrs: { pratica: _vm.pratica, nomeAba: _vm.nomeAba }
      }),
      _vm._v(" "),
      _c("TitleWithRow", { attrs: { title: "" } }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("validation-provider", {
            attrs: { mode: "lazy", name: _vm.nomeAba + "/Descrição" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c("Label", { attrs: { label: "Descrição" } }),
                        _vm._v(" "),
                        _c("el-input", {
                          class: { "input erro": errors.length },
                          attrs: {
                            name: "Descrição",
                            type: "textarea",
                            maxlength: "500",
                            "show-word-limit": ""
                          },
                          model: {
                            value: _vm.pratica.descricao,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "descricao", $$v)
                            },
                            expression: "pratica.descricao"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1567326e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1567326e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/SAF/SAF.vue
// module id = null
// module chunks = 